<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Iframe from './Iframe/index.vue';
import type { ParentBridge } from './Iframe/FrameBridge';
import { getExternalDomain } from '../../../../../shared/helpers/env';

interface Props {
  accountId?: string;
  country?: string;
  site?: string;
}

const { accountId, country, site } = defineProps<Props>();

const { t } = useI18n();
const emit = defineEmits(['close', 'refresh']);

const title = ref(t('AGENT_MGMT.ADD.TITLE'));

const onBridgeReady = (bridge: ParentBridge) => {
  bridge.on('agent:type', (type: string) => {
    if (type === 'lark') {
      title.value = 'Add new agent via Lark Account';
    }
  });
};

const onClose = (refresh?: boolean) => {
  emit('close');
  if (refresh) {
    emit('refresh');
  }
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-hidden agent-add-iframe">
    <woot-modal-header
      :header-title="title"
      :header-content="$t('AGENT_MGMT.ADD.DESC')"
    />
    <Iframe
      :src="`${getExternalDomain()}/external/agent?accountId=${accountId}&country=${country}&site=${site}`"
      @close="onClose"
      @bridge-ready="onBridgeReady"
    />
  </div>
</template>

<style scoped lang="scss">
.agent-add-iframe {
  display: flex;
  flex-direction: column;
  height: 100%;

  .iframe-container {
    flex: 1;
  }
}
</style>
